import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SampleModal from './component/SampleModal';
import TestStatusModal from './component/TestStatusModal';
import HospitalEmailModal from './HospitalEmailModal';
import TestResultModal from './component/TestResultModal';
import { generateTRFDocument } from '../src/SalesDetailsPage';
import styles from './HospitalPortal.module.css';
import { FaFilter } from 'react-icons/fa';
import Loader from './Loader';
import { ToastContainer, toast } from "react-toastify";
import './Cards.css';

import 'react-toastify/dist/ReactToastify.css';
import { formatDate } from '../src/utilities/formatDate';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { exportToExcel } from '../src/utilities/exportToExcel.js';




function HospitalPortal() {
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredTests, setFilteredTests] = useState([]);
  const [statusFilter, setStatusFilter] = useState([]);
  const [error, setError] = useState(null);
  const [selectedTest, setSelectedTest] = useState(null);
  const [sampleModalIsOpen, setSampleModalIsOpen] = useState(false);
  const [testStatusModalIsOpen, setTestStatusModalIsOpen] = useState(false);
  const [TestResultModalIsOpen, setTestResultModalIsOpen] = useState(false);
  const [HospitalemailModalIsOpen, setHospitalEmailModalIsOpen] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [relatedTests, setRelatedTests] = useState([]);
  const [dropdownVisible, setDropdownVisible] = useState(false); // State to manage dropdown visibility
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState("50");
  const [pagination, setPagination] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [fromDate, setFromDate] = useState("");
  const [statsTests, setStatsTests] = useState([]);
  const userRole=localStorage.getItem('role');

  const getDelayInfo = (test) => {
    if (
      test.sampleReceivedStatus === "Received & Accepted" || test.sampleReceivedStatus === "Received & Rejected" || test.sampleReceivedStatus === "rejected" || test.sampleReceivedStatus === "Received & Rejected" ||
      !test.SalesEntry?.PickUpdate
    ) {
      return { isDelayed: false, days: 0 };
    }
  
    const pickUpDate = new Date(test.SalesEntry.PickUpdate);
    const today = new Date();
  
    const diffTime = today - pickUpDate;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  
    if (diffDays > 4) {
      return { isDelayed: true, days: diffDays };
    }
  
    return { isDelayed: false, days: diffDays };
  };

  const totalSamples = statsTests.length;
  const pendingSamples = statsTests.filter(test => test.sampleReceivedStatus === null).length;
  const delayedSamples = statsTests.filter(test => getDelayInfo(test).isDelayed).length;
  const reportsGenerated = statsTests.filter(test => test.testStatus === null).length;

  
 const applyStatusFilter = (selectedStatuses) => {
  setStatusFilter(selectedStatuses);

  const today = new Date();

  const updatedTests = tests.filter((test) => {
    // normalize null → Pending
    const status =
      test.sampleReceivedStatus === null
        ? "Pending"
        : test.sampleReceivedStatus;

    // calculate delay
    let isDelayed = false;
    let delayDays = 0;

    if (test.SalesEntry?.PickUpdate) {
      const pickUpDate = new Date(test.SalesEntry.PickUpdate);
      delayDays = Math.floor(
        (today - pickUpDate) / (1000 * 60 * 60 * 24)
      );
      if (delayDays > 4 && status !== "Received & Accepted" && status !== "rejected" && status !== "Received & Rejected") {
        isDelayed = true;
      }
    }

    // ---- FILTER LOGIC ----
    if (selectedStatuses.length === 0) return true;

    // Pending & Delayed filter
    if (
      selectedStatuses.includes("Pending & Delayed") &&
      isDelayed
    ) {
      return true;
    }

    // Normal status filters
    if (selectedStatuses.includes(status)) {
      return true;
    }

    return false;
  });

  setFilteredTests(updatedTests);
  setDropdownVisible(false);
};
  const resetFilter = () => {
    setStatusFilter([]); // Clear the status filter
    setFilteredTests(tests); // Reset the filtered data to show all tests
    setDropdownVisible(false); // Hide the dropdown after reset
  };

   // Filtered Data based on search query and status filter
   const filteredData = filteredTests.filter((item) => {
    const rowText = `${item.SalesEntry.PatientFullName} ${item.sampleReceivedStatus} ${item.testStatus} ${item.testResult}`.toUpperCase();
    return rowText.includes(searchQuery.toUpperCase());
  });

  // useEffect(() => {
  //   const fetchTests = async () => {
  //     try {
  //        setLoading(true);
  //       const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/lab/tests`, {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem('token')}`
  //         }
  //       });
  //       const sortedTests = response.data.sort((a, b) => b.salesEntryId - a.salesEntryId);
  //       setTests(sortedTests);
  //       setFilteredTests(sortedTests); // Initialize filtered tests with all tests
  //        setLoading(false);
  //     } catch (error) {
  //       console.error('Error fetching tests:', error);
  //       setLoading(false);

  //     }
  //   };
  //   fetchTests();
  // }, []);

  const fetchTests = async ({
  page: newPage = page,
  limit: newLimit = limit,
  fromDate: newFromDate = fromDate,
} = {}) => {
  try {
    setLoading(true);

    const params = {
      page: newPage,
      limit: newLimit,
    };
    if (newFromDate) params.fromDate = newFromDate;

    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/lab/tests`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params, // <-- important
      }
    );

    // const { data, pagination } = response.data;
     let payload = response.data;
       if (payload && Array.isArray(payload.data)) {
  // prefer nested pagination first
  const p = payload.pagination || {};
  // fall back to top-level if needed
  const total = p.total ?? payload.total ?? payload.data.length ?? 0;
  console.log("total",total)
  const srvPage = p.page ?? payload.page ?? 1;
  const srvLimit = p.limit ?? payload.limit ?? 50;

 
  const srvPages = p.pages ?? payload.pages ?? Math.max(1, Math.ceil(total / srvLimit));
  console.log("srvPage",srvPage,srvLimit,srvPages)

  setTests(payload.data);
  setFilteredTests(payload.data);
  setTotal(Number(total) || 0);
  setPage(Number(srvPage) || 1);
  setLimit(String(srvLimit) || 50);
  setTotalPages(Math.max(1, Number(srvPages) || 1));
  return;
}

    // setTests(data);
    // setFilteredTests(data);

    // setPage(pagination.page);
    // setLimit(pagination.limit);
    // setTotal(pagination.total);
    // setTotalPages(pagination.pages);
  } catch (error) {
    console.error("Error fetching tests:", error);
    setError("Failed to fetch tests");
  } finally {
    setLoading(false);
  }
};

// Load tests initially
// useEffect(() => {
//   fetchTests({ page: 1, limit });
//   // eslint-disable-next-line react-hooks/exhaustive-deps
// }, []);

const fetchStatsData = async () => {
  try {
    const d = new Date();
    d.setDate(d.getDate() - 60);
    const statsFromDate = d.toISOString().split('T')[0];
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/lab/tests`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        params: { fromDate: statsFromDate, limit: 9999, page: 1 },
      }
    );
    const payload = response.data;
    if (payload && Array.isArray(payload.data)) {
      setStatsTests(payload.data);
    }
  } catch (error) {
    console.error("Error fetching stats:", error);
  }
};

useEffect(() => {
  fetchStatsData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

useEffect(() => {
  fetchTests({ page: 1, limit, fromDate });
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [limit, fromDate]);
  useEffect(() => {
    console.log("ToastContainer in DOM:", document.querySelector(".Toastify__toast-container"));
  }, []);

  const fetchTestsBySalesEntryId = async (salesEntryId) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/lab/patienttest?salesEntryId=${salesEntryId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      return response.data; // Return the tests related to the salesEntryId
    } catch (error) {
      console.error("Failed to fetch related tests", error);
      setError(error.response ? error.response.data.message : error.message);
      return [];
    }
  };

  const handleSampleReceivedStatus = async (testId, { status, date, time,expectedReportDate,rejectionReason }) => {
   
    try {
        
      await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/lab/tests/${testId}/sample-received`, 
      { sampleReceivedStatus: status, sampleReceivedDate: date, sampleReceivedTime: time ,expectedReportDate:expectedReportDate,rejectionReason:rejectionReason}, 
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      // Update the state to reflect the new status
      setTests((prevTests) => prevTests.map((test) => test.id === testId ? { ...test, sampleReceivedStatus: status, sampleReceivedDate: date, sampleReceivedTime: time,expectedReportDate:expectedReportDate } : test));
    
    setFilteredTests((prevFilteredTests) =>
      prevFilteredTests.map((test) =>
        test.id === testId
          ? {
              ...test,
              sampleReceivedStatus: status,
              sampleReceivedDate: date,
              sampleReceivedTime: time,
              expectedReportDate,
            }
          : test
      )
    );
    console.log("triggering toast 1")
    toast.success("Sample status updated successfully!");
    console.log("triggering toast 2")
  }
    
    
    
    catch (error) {
      console.error("Failed to update sample received status", error);
      setError(error.response ? error.response.data.message : error.message);
    }
  };

  const handleTestStatus = async (testId, { status, rejectionReason,resonforReupload}) => {
    try {
      await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/lab/tests/${testId}/test-status`, 
      { testStatus: status, rejectionReason,resonforReupload }, 
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      // Update the state to reflect the new status
      setTests(prevTests => prevTests.map(test => test.id === testId ? { ...test, testStatus: status, rejectionReason } : test));
      setFilteredTests((prevFilteredTests) =>
        prevFilteredTests.map((test) =>
          test.id === testId
            ? {
                ...test,
                testStatus: status,
                rejectionReason
               
              }
            : test
        )
      );
      toast.success("Report status updated successfully!");
    } catch (error) {
      console.error("Failed to update test status", error);
      setError(error.response ? error.response.data.message : error.message);
    }
  };

  const handleFileUpload = async (testId,patientName,testName,salesEntryId, file) => {
  
    const formData = new FormData();
    formData.append('report', file);
    formData.append('patientName', patientName);
    formData.append('testName', testName);
    formData.append('salesEntryId', salesEntryId);
    console.log("formdata2,",formData)

    try {
      console.log("formdata1,",formData)
      const response=await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/lab/tests/${testId}/upload-report`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      
      console.log("File uploaded successfully");
      return {
        success: true,
        filePath: response.data.filePath,
        fileName: file.name,
        message: "File uploaded successfully"
      };
      
    } catch (error) {
      console.error("Failed to upload report", error);
      const errorMessage = error.response?.data?.message || error.message || "Failed to upload file";
      setError(errorMessage);
      return {
        success: false,
        error: errorMessage
      };
    }
   
  };

  const handleSampleResult = async (testId,  { result, values, antibodies }) => {
 
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/lab/tests/${testId}/testResult`,
        { result,values,antibodies },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
      console.log("Sample result updated:", response.data);
      
      // Update the state to reflect the new result
      setTests(prevTests =>
        prevTests.map(test => 
          test.id === testId ? { ...test, testResult: result, values, antibodies } : test
        )
      );
      setFilteredTests(prevFilteredTests =>
        prevFilteredTests.map(test =>
          test.id === testId ? { ...test, testResult: result, values, antibodies } : test
        )
      );
      toast.success("Result updated successfully!");
      return true;
    } catch (error) {
      console.error("Failed to update result", error);
      const errorMessage = error.response ? error.response.data.message : error.message;
      setError(errorMessage);
      toast.error(`Failed to update result: ${errorMessage}`);
      return false;
    }
  };


  const handleDownloadTRF = async (salesEntryId) => {
    console.log("salesID",salesEntryId)
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/sales/trf/${salesEntryId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      const entry = response.data;
      console.log("entrysales",entry)
      generateTRFDocument(entry);
       setLoading(false);
    } catch (error) {
      console.error('Failed to fetch transaction details:', error);
      alert('Failed to download TRF. Please try again.');
    }
  };

  const openTestResultModal=(test, readOnly)=>{
    setSelectedTest(test);
    setReadOnly(readOnly);
    setTestResultModalIsOpen(true);

  }


  const openSampleModal = (test, readOnly) => {
    // console.log("params",test,"readonly", readOnly)
    setSelectedTest(test);
    setReadOnly(readOnly);
    setSampleModalIsOpen(true);
  };

  // Function to close the Sample Modal
  const closeSampleModal = () => {
    setSelectedTest(null);
    setSampleModalIsOpen(false);
  };

  // Function to open the Test Status Modal
  const openTestStatusModal = (test, readOnly) => {
    setSelectedTest(test);
    setReadOnly(readOnly);
    setTestStatusModalIsOpen(true);
  };




  // Function to close the Test Result Modal
  const closeTestResultModal = () => {
    setSelectedTest(null);
    setTestResultModalIsOpen(false);
  };

  // Function to open the Hospital Email Modal
  const openHospitalEmailModal = async (test) => {
    setSelectedTest(test);
    const relatedTests = await fetchTestsBySalesEntryId(test.salesEntryId);
    console.log("test in email modal,",test)
    console.log("relatedTests",relatedTests)
    setRelatedTests(relatedTests);
    setHospitalEmailModalIsOpen(true);
  };



  const closeTestStatusModal = () => {
    setSelectedTest(null);
    setTestStatusModalIsOpen(false);
  };
  const closeHospitalEmailModal = () => {
    setSelectedTest(null);
    setHospitalEmailModalIsOpen(false);
  };

  const handleSendEmail = async (recipient,test,reportUrl,emailType) => {
    setLoading(true);
    console.log("recipient",recipient,test,reportUrl,emailType)
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/lab/tests/${selectedTest.id}/send-hospital-email`, {
        recipient,reportUrl,emailType,
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      console.log("response email",response)
      
      if(response.data.message==="Email sent Successfully"){
        alert("Email sent successfully");
      } 


      console.log("Email sent successfully");
    } catch (error) {
      console.error('Failed to send email:', error);
      alert('Failed to send email Please Check the email entered');
  }
  finally {
    setLoading(false); // Stop the loader in both success and error cases
    // setHospitalEmailModalIsOpen(false);
  }
  };

  const hasDelayedSamples = filteredData.some((test) => {
  const status = test.sampleReceivedStatus ?? 'Pending';

  // Only Pending samples can be delayed
  if (status !== 'Pending') {
    return false;
  }

  if (!test.SalesEntry?.PickUpdate) {
    return false;
  }

  const pickUpDate = new Date(test.SalesEntry.PickUpdate);
  const today = new Date();

  const diffDays = Math.floor(
    (today - pickUpDate) / (1000 * 60 * 60 * 24)
  );

  return diffDays > 4;
});

  
  const handleExport = () => {
  exportToExcel(tableData, "ExportedData");
};
const tableData = tests.map((entry) => ({
  'Transaction ID': entry.id,
  'Patient Name': entry.SalesEntry.PatientFullName,
  'Patient Age': entry.SalesEntry.PatientAge,
  'Patient Gender': entry.SalesEntry.PatientGender,
  'Test':entry.test,
  'Sample':entry.sample,
  'Sample Received Date':formatDate(entry.sampleReceivedDate),
  'Sample Received Status':entry.sampleReceivedStatus,
  'sample Received Time':entry.sampleReceivedTime,
  'PickUp date':formatDate(entry.SalesEntry.PickUpdate),
  'PickUp City':entry.SalesEntry.PickUpCity,
  'City':entry.SalesEntry.City,
  'Primary Physician':entry.SalesEntry.ReferringConsultantName_PrimaryPhysician,
  'Hospital Name':entry.SalesEntry.HospitalClinicName,
  'Test Result':entry.testResult,
  'Test Value':entry.testValues,
  'Test Antibodies':entry.testAntibodies,


  


 
 
}));


  return (
    
    <div className={`${styles.hospitalPortalContainer} hospital-portal`}>
         {/* Header */}
  <div className={styles.portalHeader}>
    <div>
      <h2 style={{textAlign:"left"}}>Amrita Lab Portal</h2>
      {/* <p className={styles.portalSubtitle}>
        Sample & Report Monitoring Dashboard
      </p> */}
    </div>
  </div>
       <div className="card-container">
            <div className="card">
                <h3>Total Samples</h3>
                <p>{totalSamples}</p>
            </div>
            <div className="card">
                <h3>Samples Not Received</h3>
                <p>{pendingSamples}</p>
            </div>
            <div className="card">
                <h3>Delayed Samples</h3>
                <p>{delayedSamples}</p>
            </div>
            <div className="card">
                <h3>Reports Pending</h3>
                <p>{reportsGenerated}</p>
            </div>
        </div>
        <p style={{ textAlign: "right", fontSize: "11px", color: "#888", marginTop: "-8px", marginBottom: "8px" }}>
          * Stats based on samples from the last 60 days
        </p>
   <div className={`${styles.toolbar}`}>
    
            <div className={`${styles.paginationtoolbar}`}>
        <button
          onClick={() => page > 1 && fetchTests({ page: page - 1 })}
          disabled={loading || page <= 1}
        >
          ◀
        </button>
      
        <span>
          Page {page} / {totalPages} {total ? `(${total} total)` : ""}
        </span>
      
        <button
          onClick={() => page < totalPages && fetchTests({ page: page + 1 })}
          disabled={loading || page >= totalPages}
        >
          ▶
        </button>
      
        <label style={{ marginLeft: 10 }}>Page size:</label>
        <select
          value={limit}
          onChange={(e) => setLimit(String(e.target.value))}
          disabled={loading}
        >
          <option value={50}>50</option>
          <option value={100}>100</option>
          {/* <option value={200}>200</option> */}
          {/* <option value={500}>500</option> */}
          {/* <option value={1000}>1000</option>
          <option value={2000}>2000</option> */}
          <option value="unlimited">All</option>
        </select>
      
        {/* Optional: server-side fromDate filter */}
        <label style={{ marginLeft: 10 }}>From date:</label>
        <input
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
          disabled={loading}
        />
      
        <button
          onClick={() => fetchTests({ page: 1,limit: "50"  })}
          disabled={loading}
        >   Refresh 
          <FontAwesomeIcon icon={faSyncAlt} spin={loading} style={{ marginLeft: "8px" }}/>
        </button>
      
        {error && <span style={{ color: "crimson", marginLeft: 10 }}>{error}</span>}
      </div>
      <div className="search-container">
               {/* {<label htmlFor="searchInput">Search</label>}  */}
               { <div style={{paddingRight:"10px"}}>
              {userRole==="admin"&&<button className='exportExcel' onClick={handleExport} style={{ marginBottom: "auto" ,}}>
              <FontAwesomeIcon icon={faFileExcel} size="lg" />
              <span class="exporttooltip"  >Export to Excel</span>
             
              </button>}
              </div>  } 
              <input
                type="text"
                id="searchInput"
                placeholder="Search for names..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)} // Use React's onChange event
              />

              
            </div>
      </div> 
      
     
       {<ToastContainer position="bottom-right" autoClose={3000} />}
   
      
     
      {/* Table for displaying tests */}
          {loading ? (
  <Loader />
):(
      <div className={styles.tableWrapper}>
      <table className={`${styles.table}`}>
        <thead className={`${styles.tableHeader}`}>
          <tr>
            <th className={styles.tableHeader}>Transaction ID</th>
            <th className={styles.tableHeader}>Patient Name</th>
            <th className={styles.tableHeader}>Test</th>
            <th className={styles.tableHeader}>Sample Type</th>
            <th className={styles.tableHeader}>Pick-Up details</th>
            <th className={styles.tableHeader} style={{ position: 'relative' }} > {/* Ensure dropdown appears next to the icon */}
              {/* Filter Dropdown for Test Received Status */}
              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                           {hasDelayedSamples && (
      <span
        title="Some samples are delayed more than 4 days"
        style={{
          backgroundColor: '#f59e0b',
          color: '#fff',
          fontSize: '11px',
          fontWeight: '600',
          padding: '2px 6px',
          borderRadius: '12px',
          whiteSpace: 'nowrap'
        }}
      >
        ⚠ Delayed
      </span>
    )}
                Sample Received Status
       
 
                <FaFilter
                  onClick={() => setDropdownVisible(!dropdownVisible)}
                  style={{ cursor: 'pointer', marginLeft: '8px' }}
                />
              </span>

                {/* Single Dropdown for Test Received Status */}
                {dropdownVisible && (
                  <div className={styles.dropdownContainer}>
                    <h4 style={{color:"Black"}}>Filter by Status</h4>
                    <div className={styles.filterOptions}>
                      <label>
                        <input
                          type="checkbox"
                          checked={statusFilter.includes('Pending')}
                          onChange={() =>
                            setStatusFilter((prev) =>
                              prev.includes('Pending')
                                ? prev.filter((status) => status !== 'Pending')
                                : [...prev, 'Pending']
                            )
                          }
                        />
                        In Transit
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          checked={statusFilter.includes('Received & Accepted')}
                          onChange={() =>
                            setStatusFilter((prev) =>
                              prev.includes('Received & Accepted')
                                ? prev.filter((status) => status !== 'Received & Accepted')
                                : [...prev, 'Received & Accepted']
                            )
                          }
                        />
                        Received & Accepted
                      </label>
                      <label>
                        <input
                          type="checkbox"
                          checked={statusFilter.includes('Received & Rejected')}
                          onChange={() =>
                            setStatusFilter((prev) =>
                              prev.includes('Received & Rejected')
                                ? prev.filter((status) => status !== 'Received & Rejected')
                                : [...prev, 'Received & Rejected']
                            )
                          }
                        />
                        Received & Rejected
                      </label>
                       <label>
                        <input
                          type="checkbox"
                          checked={statusFilter.includes('Pending & Delayed')}
                          onChange={() =>
                            setStatusFilter((prev) =>
                              prev.includes('Pending & Delayed')
                                ? prev.filter((status) => status !== 'Pending & Delayed')
                                : [...prev, 'Pending & Delayed']
                            )
                          }
                        />
                        Delayed
                      </label>
                    </div>

                    {/* Apply and Reset Buttons */}
                    <div className={styles.buttonContainer}>
                      <button onClick={resetFilter} className={styles.resetButton}>
                        Reset
                      </button>
                      {console.log("statusFilter",statusFilter)}
                      <button onClick={() => applyStatusFilter(statusFilter)} className={styles.applyButton}>
                        Apply
                      </button>
                    </div>
                  </div>
                )}
            </th>
            <th className={styles.tableHeader}>Sample Received Date</th>
            <th className={styles.tableHeader}>TRF</th>
            <th className={styles.tableHeader}>Test Report</th>
            {userRole==="admin"&&<th className={styles.tableHeader}>Result</th>}
            {userRole==="admin"&&<th className={styles.tableHeader}>Action</th>}
          </tr>
        </thead>
        <tbody>
          {filteredData.map((test) => (
            <tr key={test.id}>
              <td style={{ textAlign: 'center' }}>{test.salesEntryId}</td>
              <td style={{ textAlign: 'center' }}>
    <div>{test.SalesEntry.PatientFullName}</div>
    <div style={{ fontSize: '12px', color: '#555' }}>
      {test.SalesEntry.PatientAge} yrs | {test.SalesEntry.PatientGender}
    </div>
  </td>
              <td style={{ textAlign: 'center' }}>{test.test}</td> 
              <td style={{ textAlign: 'center' }}>{test.sample}</td> 
                 <td style={{ textAlign: 'center' }}>
                    <div>{test.SalesEntry.PickUpCity}</div>
                    <div style={{ fontSize: "0.60em", color: "#555", marginTop: "2px" }}>
                        {formatDate(test.SalesEntry.PickUpdate)}
                </div>
              </td>
            
              <td style={{ textAlign: 'center' }}>
                <button
                  onClick={() =>
                    openSampleModal(
                      test,
                      test.sampleReceivedStatus === 'Received & Accepted' ||
                        test.sampleReceivedStatus === 'Received & Rejected'
                    )
                  }
                  className={
                    styles[
                      test.sampleReceivedStatus === 'Received & Accepted'
                        ? 'accepted'
                        : test.sampleReceivedStatus === 'Received & Rejected'
                        ? 'rejected'
                        : 'pending'
                    ]
                  }
                  style={{ margin: '0 auto' }} // Center button horizontally
                >
                  {(() => {
                      // ---- Delay calculation ----
                      let isDelayed = false;
                      let delayDays = 0;

                      if (
                        test.sampleReceivedStatus !== 'Received & Accepted'&&  test.sampleReceivedStatus !== 'Received & Rejected' &&
                        test.SalesEntry?.PickUpdate
                      ) {
                        const pickUpDate = new Date(test.SalesEntry.PickUpdate);
                        const today = new Date();

                        const diffTime = today - pickUpDate;
                        delayDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

                        if (delayDays > 4) {
                          isDelayed = true;
                        }
                      }

                      // ---- Button label ----
                      const statusText =
                        test.sampleReceivedStatus === 'Received & Accepted'
                          ? 'Received & Accepted'
                          : test.sampleReceivedStatus === 'Received & Rejected'
                          ? 'Received & Rejected'
                          : 'Pending';

                      return (
                        <>
                          {statusText}

                          {isDelayed && (
                            <span
                              title={`Sample pending for ${delayDays} days since pickup`}
                              style={{
                                marginLeft: '6px',
                                color: '#d97706', // amber/orange
                                fontSize: '12px',
                                fontWeight: '600',
                                whiteSpace: 'nowrap'
                              }}
                            >
                              ⚠ Delayed ({delayDays}d)
                            </span>
                          )}
                        </>
                      );
                    })()}
                </button>

              </td>
              <td style={{ textAlign: 'center',margin: '0 auto'}}>
                <span className={styles[test.sampleReceivedDate ? 'accepted' : 'pending']}
                 style={{ padding: '3px 10px', borderRadius: '4px', display: 'inline-block',fontSize:'13px' }}>
                  {test.sampleReceivedDate ? 
                  (() => {
                        const date = new Date(test.sampleReceivedDate);
                        const day = String(date.getDate()).padStart(2, '0');
                        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                        const month = monthNames[date.getMonth()];
                        const year = date.getFullYear();
                        return `${day}-${month}-${year}`;
                      })()
                    : 'Pending'}</span>
              </td>
              <td style={{ textAlign: 'center' }}>
                 <span
                 title={test.sampleReceivedStatus === null ? 'TRF can be downloaded once the sample received date & status is updated': ''} style={{ display: 'inline-block' }}>
                <button
                  className={styles['download-button']}
                  onClick={() => handleDownloadTRF(test.salesEntryId)}
                  style={{ margin: '0 auto' }} // Center button horizontally
                  disabled={test.sampleReceivedStatus === null}
                >
                  Download
                </button>
                </span>
              </td>
              <td style={{ textAlign: 'center' }}>
                <button
                  onClick={() => openTestStatusModal(test, test.testStatus === 'Accepted')}
                  className={
                    styles[
                      test.testStatus === 'Accepted'
                        ? 'accepted'
                        : test.testStatus === 'Rejected'
                        ? 'rejected'
                        : 'pending'
                    ]
                  }
                  style={{ margin: '0 auto' }} // Center button horizontally
                >
                  {test.testStatus === 'Accepted' ? 'Reported' : test.testStatus === 'Rejected' ? 'Rejected' : 'Pending'}
                </button>
                 {test.reportUploadedAt && (
                    <div style={{ fontSize: "0.60em", color: "#555", marginTop: "2px" }}>
                      {formatDate(test.reportUploadedAt,{time:true})}
                    </div>
                  )}
              </td>
           
             {userRole==="admin"&& <td style={{ textAlign: 'center' }}>
                <button
                  onClick={() => openTestResultModal(test, test.testResult === 'Positive' || test.testResult === 'Negative')}
                  className={
                    styles[
                      test.testResult === 'Positive'
                        ? 'accepted'
                        : test.testResult === 'Negative'
                        ? 'rejected'
                        : 'pending'
                    ]
                  }
                  style={{ margin: '0 auto' }} // Center button horizontally
                >
                  {test.testResult === 'Positive'
                    ? 'Positive'
                    : test.testResult === 'Negative'
                    ? 'Negative'
                    : 'Enter Result'}
                </button>
              </td>}
              {userRole==="admin"&&<td style={{ textAlign: 'center' }}>
                <button
                  onClick={() => openHospitalEmailModal(test)}
                  style={{
                    backgroundColor: '#1f78b4',
                    color: '#ffffff',
                    border: 'none',
                    padding: '8px 12px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    margin: '0 auto' // Center button horizontally
                  }}
                >
                  Send Email
                </button>
              </td>}
      
            </tr>
          ))}
        </tbody>
      </table>
      </div>
  )}
      {/* Modals for various actions */}
      {selectedTest && (
        <SampleModal
          isOpen={sampleModalIsOpen}
          onRequestClose={closeSampleModal}
          test={selectedTest}
          handleSampleReceivedStatus={handleSampleReceivedStatus}
          readOnly={readOnly}
        />
      )}
      {selectedTest && (
        <TestStatusModal
          isOpen={testStatusModalIsOpen}
          onRequestClose={closeTestStatusModal}
          test={selectedTest}
          handleTestStatus={handleTestStatus}
          handleFileUpload={handleFileUpload}
          readOnly={readOnly}
        />
      )}
      {selectedTest && relatedTests.length > 0 && (
        <HospitalEmailModal
          isOpen={HospitalemailModalIsOpen}
          onRequestClose={closeHospitalEmailModal}
          test={relatedTests}
          SendEmail={handleSendEmail}
        />
      )}
      {selectedTest && (
        <TestResultModal
          isOpen={TestResultModalIsOpen}
          onRequestClose={closeTestResultModal}
          test={selectedTest}
          handleSampleResult={handleSampleResult}
        />
      )}
    </div>
  );
  
}


    


export default HospitalPortal;
